export enum UnitOfMeasurement {
  Sheet = 'Sheet',
  Bag = 'Bag',
  Block = 'Block',
  Bottle = 'Bottle',
  Each = 'Each',
  Gram = 'Gram',
  UsGallon = 'US gallon',
  Kilogram = 'Kilogram',
  KilogramHour = 'Kilogramhour',
  Litre = 'Litre',
  UsPound = 'US pound',
  OngoingMeter = 'Ongoing meter',
  Metre = 'Metre',
  SquareMetre = 'Square metre',
  CubicMetre = 'Cubic metre',
  Millilitre = 'Millilitre',
  Pallet = 'Pallet',
  Roll = 'Roll',
  Sack = 'Sack',
  Set = 'Set',
  Items = 'Items',
  Board = 'Board',
  Thousands = 'Thousands',
  Tonnes = 'Tonnes',
  Other = 'Other'
}

export enum MeasurementType {
  Auto = 'Auto',
  Manual = 'Manual'
}

export enum Status {
  Created = 'Created',
  Edited = 'Edited',
  Deleted = 'Deleted',
  // only for FE
  New = 'New'
}

export enum AssetLinkType {
  Asset = 'Asset',
  Conveyor = 'Conveyor',
  Silo = 'Silo'
}

export enum LinkDirection {
  To = 'to',
  From = 'from'
}

export enum OperationModeType {
  Production = 'Production',
  Maintenance = 'Maintenance'
}

export enum AssetType {
  CementMill = 'CementMill',
  RawMill = 'RawMill',
  RotaryKiln = 'RotaryKiln',
  Other = 'Other',
  BaseLoad = 'BaseLoad',
  Crusher = 'Crusher',
  CoalMill = 'CoalMill'
}
